import {
  SUBMIT_FEEDBACK,
  SUBMIT_FEEDBACK_SUCCESSFUL,
  SUBMIT_FEEDBACK_FAILED,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESSFUL,
  VERIFY_CODE_FAILED,
  INTERVIEW_FEEDBACK,
  INTERVIEW_FEEDBACK_SUCCESSFUL,
  INTERVIEW_FEEDBACK_FAILED,
  SHORTLIST_FEEDBACK,
  SHORTLIST_FEEDBACK_FAILED,
  SHORTLIST_FEEDBACK_SUCCESSFUL,
  VERIFY_CODE_SHORTLIST,
  VERIFY_CODE_SHORTLIST_SUCCESSFUL,
  VERIFY_CODE_SHORTLIST_FAILED,
  GET_INTERVIEWERS_LIST,
  GET_INTERVIEWERS_LIST_SUCCESS,
  GET_INTERVIEWERS_LIST_FAIL,
  GET_FEEDBACK_CANDIDATE_DATA,
  GET_FEEDBACK_CANDIDATE_DATA_SUCCESS,
  GET_FEEDBACK_CANDIDATE_DATA_FAIL,
  GET_SHORTLIST_DATA,
  GET_SHORTLIST_DATA_SUCCESS,
  GET_SHORTLIST_DATA_FAIL,
  GET_CANDIDATE_RESUME_DETAILS,
  GET_CANDIDATE_RESUME_DETAILS_SUCCESS,
  GET_CANDIDATE_RESUME_DETAILS_FAIL,
  GET_CANDIDATES_MODAL_DATA,
  GET_CANDIDATES_MODAL_DATA_SUCCESS,
  GET_CANDIDATES_MODAL_DATA_FAIL,
  GET_SHORLISTING_CANDIDATES_LIST,
  GET_SHORLISTING_CANDIDATES_LIST_SUCCESS,
  GET_SHORLISTING_CANDIDATES_LIST_FAIL,
  GET_SEARCH_SHORTLISTING_CANDIDATE,
  GET_OFFER_DATA,
  GET_OFFER_DATA_SUCCESS,
  GET_OFFER_DATA_FAIL,
  POST_OFFER_DATA,
  POST_OFFER_DATA_SUCCESS,
  POST_OFFER_DATA_FAIL,
  GET_HIRE_CANDIDATE_LIST,
  GET_HIRE_CANDIDATE_LIST_SUCCESS,
  GET_HIRE_CANDIDATE_LIST_FAIL,
  SUBMIT_HIRING_FEEDBACK_DATA,
  SUBMIT_HIRING_FEEDBACK_DATA_SUCCESS,
  SUBMIT_HIRING_FEEDBACK_DATA_FAIL,
  GET_HIRE_SUBMIT_FEEDBACK_STATUS,
  GET_HIRE_SUBMIT_FEEDBACK_STATUS_SUCCESS,
  GET_HIRE_SUBMIT_FEEDBACK_STATUS_FAIL,
  GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS,
  GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS,
  GET_HIRING_INTERVIEWER_LIST,
  GET_HIRING_FEEDBACK_CANDIDATE_DATA,
  GET_HIRING_SHORTLIST_DATA,
  GET_HIRE_CANDIDATE_RESUME_DETAILS,
  GET_SHORTLIST_FILTER_DATA,
  GET_INTERVIEW_QUESTION_LIST,
  GET_INTERVIEW_QUESTION_LIST_SUCCESS,
  GET_INTERVIEW_QUESTION_LIST_FAIL,
  GET_INTERVIEW_QUESTION_REVIEW_LIST,
  GET_INTERVIEW_QUESTION_REVIEW_LIST_SUCCESS,
  GET_INTERVIEW_QUESTION_REVIEW_LIST_FAIL,
  GET_INTERVIEW_QUESTION_LIST_ID,
  GET_INTERVIEW_QUESTION_LIST_ID_SUCCESS,
  GET_INTERVIEW_QUESTION_LIST_ID_FAIL,
  GET_HIRING_INTERVIEWER_LIST_SUCCESS,
  GET_HIRING_INTERVIEWER_LIST_FAIL,
} from "./actionTypes";

export const submitFeedBack = (feedBack) => {
  return {
    type: SUBMIT_FEEDBACK,
    payload: { feedBack },
  };
};
export const submitFeedBackSuccessful = (message) => {
  return {
    type: SUBMIT_FEEDBACK_SUCCESSFUL,
    payload: { message },
  };
};

export const submitFeedBackFailed = (message) => {
  return {
    type: SUBMIT_FEEDBACK_FAILED,
    payload: { message },
  };
};

//Interviewer feedback

export const verifyCode = (code) => {
  return {
    type: VERIFY_CODE,
    payload: { code },
  };
};
export const verifyCodeSuccessful = (message) => {
  return {
    type: VERIFY_CODE_SUCCESSFUL,
    payload: { message },
  };
};

export const verifyCodeFailed = (message) => {
  return {
    type: VERIFY_CODE_FAILED,
    payload: { message },
  };
};

export const submitInterviewerFeedBack = (feedBack) => {
  return {
    type: INTERVIEW_FEEDBACK,
    payload: { feedBack },
  };
};
export const submitInterviewerFeedBackSuccessful = (feedBack) => {
  return {
    type: INTERVIEW_FEEDBACK_SUCCESSFUL,
    payload: { feedBack },
  };
};

export const submitInterviewerFeedBackFailed = (feedBack) => {
  return {
    type: INTERVIEW_FEEDBACK_FAILED,
    payload: { feedBack },
  };
};

//Shortlist feedback

export const verifyShortlistCode = (code) => {
  return {
    type: VERIFY_CODE_SHORTLIST,
    payload: { code },
  };
};
export const verifyShortlistCodeSuccessful = (message) => {
  return {
    type: VERIFY_CODE_SHORTLIST_SUCCESSFUL,
    payload: { message },
  };
};

export const verifyShortlistCodeFailed = (message) => {
  return {
    type: VERIFY_CODE_SHORTLIST_FAILED,

    payload: { message },
  };
};

export const submitShortlistFeedBack = (feedBack) => {
  return {
    type: SHORTLIST_FEEDBACK,
    payload: { feedBack },
  };
};
export const submitShortlistFeedBackSuccessful = (feedBack) => {
  return {
    type: SHORTLIST_FEEDBACK_SUCCESSFUL,
    payload: { feedBack },
  };
};

export const submitShortlistFeedBackFailed = (feedBack) => {
  return {
    type: SHORTLIST_FEEDBACK_FAILED,
    payload: { feedBack },
  };
};

// Inerviewer details

export const getInterviewerDetailsList = (json) => {
  return {
    type: GET_INTERVIEWERS_LIST,
    payload: { json },
  };
};

export const getInterviewerDetailsListSuccess = (interviewerList) => {
  return {
    type: GET_INTERVIEWERS_LIST_SUCCESS,
    payload: { interviewerList },
  };
};

export const getInterviewerDetailsListFail = (errorMsg) => {
  return {
    type: GET_INTERVIEWERS_LIST_FAIL,
    payload: { errorMsg },
  };
};

// candidateDetails

export const getFeedBackCandidateData = (json) => {
  return {
    type: GET_FEEDBACK_CANDIDATE_DATA,
    payload: { json },
  };
};

export const getCandidateDataSuccess = (candidateData) => {
  return {
    type: GET_FEEDBACK_CANDIDATE_DATA_SUCCESS,
    payload: { candidateData },
  };
};

export const getCandidateDatatFail = (errorMsg) => {
  return {
    type: GET_FEEDBACK_CANDIDATE_DATA_FAIL,
    payload: { errorMsg },
  };
};

//screening and shortlist
export const getShortListData = (json) => {
  return {
    type: GET_SHORTLIST_DATA,
    payload: { json },
  };
};

export const getShortListDataSuccess = (shortListData) => {
  return {
    type: GET_SHORTLIST_DATA_SUCCESS,
    payload: { shortListData },
  };
};

export const getShortListDataFail = (errorMsg) => {
  return {
    type: GET_SHORTLIST_DATA_FAIL,
    payload: { errorMsg },
  };
};

export const getCandidateResumeDetails = (json) => {
  return {
    type: GET_CANDIDATE_RESUME_DETAILS,
    payload: { json },
  };
};

export const getCandidateResumeDetailsSuccess = (candidateResumeDetails) => {
  return {
    type: GET_CANDIDATE_RESUME_DETAILS_SUCCESS,
    payload: { candidateResumeDetails },
  };
};

export const getCandidateResumeDetailsFail = (errorMsg) => {
  return {
    type: GET_CANDIDATE_RESUME_DETAILS_FAIL,
    payload: { errorMsg },
  };
};

//short lsit
export const getCandidateShorlistingData = (jsonData) => {
  return {
    type: GET_SHORLISTING_CANDIDATES_LIST,
    payload: { jsonData },
  };
};

export const getCandidateShorlistingDataSuccess = (candidateList) => {
  return {
    type: GET_SHORLISTING_CANDIDATES_LIST_SUCCESS,
    payload: { candidateList },
  };
};

export const getCandidateShorlistingDataFail = (errorMsg) => {
  return {
    type: GET_SHORLISTING_CANDIDATES_LIST_FAIL,
    payload: { errorMsg },
  };
};

//short list and filter

export const getShortListSortData = (jsonData) => {
  return {
    type: GET_SHORTLIST_FILTER_DATA,
    payload: { jsonData },
  };
};

export const searchCandidateShorlisting = (searchData) => {
  return {
    type: GET_SEARCH_SHORTLISTING_CANDIDATE,
    payload: { searchData },
  };
};

export const getCandidateModalData = (data) => {
  return {
    type: GET_CANDIDATES_MODAL_DATA,
    payload: { data },
  };
};

export const getCandidateModalDataSuccess = (candidateModal) => {
  return {
    type: GET_CANDIDATES_MODAL_DATA_SUCCESS,
    payload: { candidateModal },
  };
};

export const getCandidateModalDataDataFail = (errorMsg) => {
  return {
    type: GET_CANDIDATES_MODAL_DATA_FAIL,
    payload: { errorMsg },
  };
};

export const getOfferDetails = (code) => {
  return {
    type: GET_OFFER_DATA,
    payload: code,
  };
};

export const getOfferDetailsSuccess = (offerDetail) => {
  return {
    type: GET_OFFER_DATA_SUCCESS,
    payload: offerDetail,
  };
};

export const getOfferDetailsFail = (errorMsg) => {
  return {
    type: GET_OFFER_DATA_FAIL,
    payload: errorMsg,
  };
};

// offer page post form data
export const postOfferData = (feedBack) => {
  return {
    type: POST_OFFER_DATA,
    payload: feedBack,
  };
};
export const postOfferDataSuccess = (offerSuccess) => {
  return {
    type: POST_OFFER_DATA_SUCCESS,
    payload: offerSuccess,
  };
};
export const postOfferDataFail = (offerFail) => {
  return {
    type: POST_OFFER_DATA_FAIL,
    payload: offerFail,
  };
};

// hire candidate list

export const gethireCandidateList = (id) => {
  return {
    type: GET_HIRE_CANDIDATE_LIST,
    payload: { id },
  };
};
export const gethireCandidateListSuccess = (HirecandidateList) => {
  return {
    type: GET_HIRE_CANDIDATE_LIST_SUCCESS,
    payload: { HirecandidateList },
  };
};
export const gethireCandidateListFail = (errorMsg) => {
  return {
    type: GET_HIRE_CANDIDATE_LIST_FAIL,
    payload: { errorMsg },
  };
};

export const submitHireFeedback = (feedbackData) => {
  return {
    type: SUBMIT_HIRING_FEEDBACK_DATA,
    payload: { feedbackData },
  };
};
export const submitHireFeedbackSuccess = (message) => {
  return {
    type: SUBMIT_HIRING_FEEDBACK_DATA_SUCCESS,
    payload: { message },
  };
};
export const submitHireFeedbackFail = (errorMsg) => {
  return {
    type: SUBMIT_HIRING_FEEDBACK_DATA_FAIL,
    payload: { errorMsg },
  };
};

export const getSubmitHireFeedbackStatus = (code) => {
  return {
    type: GET_HIRE_SUBMIT_FEEDBACK_STATUS,
    payload: { code },
  };
};
export const getSubmitHireFeedbackStatusSuccess = (status) => {
  return {
    type: GET_HIRE_SUBMIT_FEEDBACK_STATUS_SUCCESS,
    payload: { status },
  };
};
export const getSubmitHireFeedbackStatusFail = (errorMsg) => {
  return {
    type: GET_HIRE_SUBMIT_FEEDBACK_STATUS_FAIL,
    payload: { errorMsg },
  };
};

// shortlist submitStatus

export const getshortlistSubmitFeedbackStatus = (code) => {
  return {
    type: GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS,
    payload: { code },
  };
};

//interviewer submitStatus
export const getInterviewerSubmitFeedbackStatus = (json) => {
  return {
    type: GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS,
    payload: { json },
  };
};

//Hiring interviewer list

export const getHiringInterviewerList = (code) => {
  return {
    type: GET_HIRING_INTERVIEWER_LIST,
    payload: { code },
  };
};

//hiring feedback page candidate List

export const getHiringFeedbackCandidateList = (code) => {
  return {
    type: GET_HIRING_FEEDBACK_CANDIDATE_DATA,
    payload: { code },
  };
};

//hiring feedback page shortlist data
export const getHiringShortListData = (code) => {
  return {
    type: GET_HIRING_SHORTLIST_DATA,
    payload: { code },
  };
};

export const getHireCandidateResumeDetails = (code) => {
  return {
    type: GET_HIRE_CANDIDATE_RESUME_DETAILS,
    payload: { code },
  };
};
// Interview questions

export const getInterviewQuestionList = (json) => {
  return {
    type: GET_INTERVIEW_QUESTION_LIST,
    payload: { json },
  };
};

export const getInterviewQuestionListSuccess = (interviewerList) => {
  return {
    type: GET_INTERVIEW_QUESTION_LIST_SUCCESS,
    payload: { interviewerList },
  };
};

export const getInterviewQuestionListFail = (errorMsg) => {
  return {
    type: GET_INTERVIEW_QUESTION_LIST_FAIL,
    payload: { errorMsg },
  };
};

// Interview questions review check

export const getInterviewQuestionListReview = (json) => {
  return {
    type: GET_INTERVIEW_QUESTION_REVIEW_LIST,
    payload: { json },
  };
};

export const getInterviewQuestionListReviewSuccess = (interviewerList) => {
  return {
    type: GET_INTERVIEW_QUESTION_REVIEW_LIST_SUCCESS,
    payload: { interviewerList },
  };
};

export const getInterviewQuestionListReviewFail = (errorMsg) => {
  return {
    type: GET_INTERVIEW_QUESTION_REVIEW_LIST_FAIL,
    payload: { errorMsg },
  };
};

// Interview questions

export const getInterviewQuestionListById = (json) => {
  return {
    type: GET_INTERVIEW_QUESTION_LIST_ID,
    payload: { json },
  };
};

export const getInterviewQuestionListByIdSuccess = (interviewerList) => {
  return {
    type: GET_INTERVIEW_QUESTION_LIST_ID_SUCCESS,
    payload: { interviewerList },
  };
};

export const getInterviewQuestionListByIdFail = (errorMsg) => {
  return {
    type: GET_INTERVIEW_QUESTION_LIST_ID_FAIL,
    payload: { errorMsg },
  };
};

export const getHiringInterviewerListSuccess = (interviewerList) => {
  return {
    type: GET_HIRING_INTERVIEWER_LIST_SUCCESS,
    payload: { interviewerList },
  };
};

export const getHiringInterviewerListFail = (errorMsg) => {
  return {
    type: GET_HIRING_INTERVIEWER_LIST_FAIL,
    payload: { errorMsg },
  };
};
